import { sizeClasses } from "../../constants";
import { IconProps } from "../../types";
const SvgBell = ({ size = "regular", className = "", ...props }: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      className={`${sizeClasses[size]} ${className}`}
      {...props}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M8.33 5.27a5.188 5.188 0 0 1 8.86 3.673c0 3.387.616 5.512 1.391 6.818q.108.183.221.345H5.2q.115-.165.225-.351c.773-1.308 1.385-3.433 1.385-6.812 0-1.378.547-2.7 1.52-3.673M7.27 4.21a6.688 6.688 0 0 1 11.42 4.733c0 3.223.589 5.055 1.18 6.052.296.498.59.785.812.942.179.127.293.159.32.166l.007.002H21a.75.75 0 0 1 0 1.5H3a.75.75 0 1 1 0-1.5h-.008L3 16.103a1 1 0 0 0 .324-.167c.223-.158.516-.447.81-.945.592-1 1.177-2.831 1.177-6.048 0-1.775.705-3.478 1.96-4.734m3.38 14.993a.75.75 0 0 0-1.453.377A2.9 2.9 0 0 0 12 21.748a2.895 2.895 0 0 0 2.803-2.168.75.75 0 0 0-1.452-.377 1.4 1.4 0 0 1-1.35 1.045 1.395 1.395 0 0 1-1.352-1.045"
        clipRule="evenodd"
      />
    </svg>
  );
};
export default SvgBell;
